import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import metaBizNode from '../../metaBizNode.mjs'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, prjId, subTypeCode, sVer} = map.data

    if (! (
        'BODA2' === subTypeCode &&
        'SA_MAP' === mapTypeCode
    )) {
        return null
    }

    const onClick = async () => {
        const {name, textProp} = metaBizNode.FM
        const fmIds = []
        const fmNames = []

        for (const n of map.selectedNodes) {
            const {bizNodeType, pkid, [textProp]: text} = n.data

            if ('FM' === bizNodeType) {
                fmIds.push(pkid)
                fmNames.push(text)
            }
        }

        if (0 === fmIds.length) {
            await openModal(
                <Alert type="error">未选择{name}</Alert>
            )

            return
        }

        openWindow(
            '/Ai',

            {
                bizMap: {fmIds},
                prjId,
                scene: 'GENERATE_NDT',
                sVer,
                title: `${name}: ${fmNames.join(', ')}`,
            }
        )
    }

    return {
        label: '新建数据表',
        onClick,
    }
}
